import type { IObservableArray } from 'mobx';
import { makeAutoObservable, observable } from 'mobx';

export class SortedOptionsStore<T extends { id: number }> {
  items: IObservableArray<T> = observable.array<T>([], {
    deep: false,
  });

  constructor() {
    makeAutoObservable(this);
  }

  setItems(items: T[]) {
    const sorted = [...items].sort((a, b) => a.id - b.id);
    this.items.replace(sorted);
  }

  findIndexById(id: number): number {
    const arr = this.items;
    let left = 0;
    let right = arr.length - 1;

    while (left <= right) {
      const mid = Math.floor((left + right) / 2);
      const midId = arr[mid].id;

      if (midId === id) {
        return mid;
      }

      if (midId < id) {
        left = mid + 1;
      } else {
        right = mid - 1;
      }
    }
    return -1;
  }

  findById(id: number): T | undefined {
    const index = this.findIndexById(id);
    return index !== -1 ? this.items[index] : undefined;
  }

  get size(): number {
    return this.items.length;
  }

  get hasItems(): boolean {
    return this.items.length > 0;
  }

  clear() {
    this.items.clear();
  }
}
